import { ComponentProps } from 'react'
import { webchatClasses } from '../../styles/classes'

export type FabProps = ComponentProps<'div'> & {
  onClick?: () => void
  imgUrl?: string
}

export const Fab = ({ ref, onClick, imgUrl, ...props }: FabProps) => {
  const { fab } = webchatClasses
  const { container, icon, image } = fab ?? {}

  return imgUrl ? (
    <img src={imgUrl} role="button" tabIndex={0} {...image} draggable="false" onClick={onClick} />
  ) : (
    <div {...props} {...container} ref={ref} onClick={onClick}>
      <div {...icon} />
    </div>
  )
}

Fab.displayName = 'Fab'
